import { ensureFoodProfileConditions } from 'apps/foodProfile/actions/foodProfile';
import { setNoRouteAccess } from 'apps/user/actions/user';

/**
 * Updates condition value in FM profile
 * @see src\lib\apps\foodProfile\actions\foodProfile.js
 * @param {import("./actions/foodProfile").FMProfile} profile FoodMaestro profile
 * @param {string} conditionID ID of conditition to update
 * @param {number} conditionValue New value for condition (1 - selected, 0 - not selected)
 * @returns {import("./actions/foodProfile").FMProfile} updated profile
 */
export function setProfileCondition(profile, conditionID, conditionValue) {
  return {
    ...profile,
    Conditions: profile.Conditions.map(condition => ({
      ...condition,
      ConditionSelected: condition.ConditionID === conditionID ? conditionValue : condition.ConditionSelected,
    })),
  };
}

/**
 * onEnterHandler for Food Profile settings page
 */
export function loadFoodProfileConditions(nextState, replace, path, extras) {
  const { store: { dispatch } } = extras;

  return dispatch(ensureFoodProfileConditions()).catch(
    () => dispatch(setNoRouteAccess())
  );
}
